import script from "./InsufficientTokensModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InsufficientTokensModal.vue?vue&type=script&setup=true&lang=js"

import "./InsufficientTokensModal.vue?vue&type=style&index=0&id=ce54813c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce54813c"]])

export default __exports__